import React, { useEffect, useState } from "react";
import { FormCadastro } from "./components/form-cadastro";
import { InfoChamada } from "./components/info-chamada";
import { Historico } from "./components/historico";
import { FormPropostas } from "./components/form-proposta";
import { FormNeg } from "./components/form-neg";
import { Credor, useDividas } from "../../../context/DividasContext";
import { useIsMutating } from "@tanstack/react-query";
import { Loader } from "../../generics/loader";
import { useContrato } from "../../../context/ContratoContext";
import { usePropostas } from "../../../context/PropostasContext";
import { ModalSucesso } from '../../Modal/components/sucesso'
import { useHistorico } from "../../../context/HistoricoContext";
import { useBoleto } from "../../../context/BoletoContext";
import { useFila } from "../../../context/FilaContext";
import { ModalErro } from "../../Modal/components/erro";
import { GenericModal } from "../../Modal";
import { useModal } from "../../../hooks/ModalContext";

interface AtendimentoFormsProps {
  isConsulta?: boolean;
}

export const AtendimentoForms = ({ isConsulta }: AtendimentoFormsProps) => {
  const [formAba, setFormAba] = useState("Cadastro");
  const { devedor, credores, getDevedorCadastro, getSelectedCredor, clearDividas, clearDevedorCadastro } = useDividas()
  const { clearPropostas } = usePropostas()
  const { getContracts, contratosData, clearContratos } = useContrato()
  const { getHistorico, historico, clearHistorico } = useHistorico()
  const { clearBoleto } = useBoleto()
  const { clearSelectedFila } = useFila()
  const { modalInfo, onClose } = useModal()

  //Limpar dados td vez q começar com um novo devedor
  useEffect(() => {
    clearPropostas()
    clearContratos()
    clearHistorico()
    clearBoleto()
    clearDevedorCadastro()

  }, [devedor])

  useEffect(() => {
    clearDividas()
    clearSelectedFila()
  }, [])

  const [credor, setCredor] = useState<Credor>(credores[0]);

  // const isMutationLogin = useIsMutating({ mutationKey: ['login'] })
  const isMutation = useIsMutating({ mutationKey: ['form'] })

  useEffect(() => {
    setCredor(credores[0])
    getSelectedCredor(credores[0])
    setFormAba("Cadastro")
  }, [credores])

  async function getCredor(credor: Credor) {
    setCredor(credor)
    getSelectedCredor(credor)
    const url = credor?.url_ws || ''
    const cpf_cnpj = devedor?.cpf_cnpj || ''
    const codcredor = credor?.credor_crm || 0
    await getDevedorCadastro(url, cpf_cnpj, codcredor)
  }

  useEffect(() => {
    if (credor?.credor_crm && devedor !== null && devedor?.cpf_cnpj) {
      getContracts({ url: credor?.url_ws, cpf_cnpj: devedor?.cpf_cnpj, credor: credor?.credor_crm })
      getHistorico({ url: credor?.url_ws, cpf_cnpj: devedor?.cpf_cnpj, codcredor: String(credor?.credor_crm) })
    }
  }, [credor])




  return (
    <div className={`flex max-h-full min-h-full  ${isConsulta ? 'w-[99%]' : 'w-[80%]'} flex-col items-center rounded-md bg-white px-4 py-4`}>

      <div className="w-full">
        <ul className=" flex w-full flex-wrap gap-2  ">
          {
            devedor && credores?.length > 0 ? credores?.map(credo => (<li
              className={`credor ${credor?.nome === credo?.nome && "brightness-[85%] border-2"} flex items-center justify-center`}
              onClick={() => getCredor(credo)}
              key={credo?.credor_crm}
            >
              <img src={credo?.logo} alt="" className="w-[3.8rem] mt-1" />
            </li>)) : <></>

          }

        </ul>
        <div className="border-b-2 border-gray-100 brightness-95"></div>
      </div>

      <div className="text-md mt-8 w-full border-b-2 border-primary text-center text-sm font-medium text-gray-500">
        <ul className="flex flex-wrap gap-2">
          <li
            className={` aba-form ${formAba === "Cadastro" &&
              "  border-2  border-b-0 border-primary text-primary underline"
              }`}
            onClick={() => setFormAba("Cadastro")}
          >
            <p>Cadastro</p>
          </li>
          <li
            className={` ${formAba === "Negociações" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${contratosData && contratosData.contratos?.length > 0 ? 'aba-form' : 'opacity-70 items-center justify-center flex h-10 pointer-events-none'}`}
            onClick={() => {
              if (contratosData && contratosData.contratos.length > 0) {
                setFormAba("Negociações")
              }
            }}
          >
            <p>Análise Contra Proposta</p>
          </li>
          <li
            className={` ${formAba === "Tabulações" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${historico.acionamentos && historico.acionamentos.acionamento?.length > 0 ? 'aba-form' : 'opacity-70 items-center justify-center flex h-10 pointer-events-none'}`}
            onClick={() => setFormAba("Tabulações")}
          >
            <p>Tabulações</p>
          </li>

          <li
            className={` aba-form ${formAba === "Chamada" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${devedor?.cpf_cnpj ? 'aba-form' : 'opacity-70 items-center justify-center flex h-10 pointer-events-none'}`}
            onClick={() => setFormAba("Chamada")}
          >
            <p>Canal de Origem</p>
          </li>



        </ul>
      </div>

      <div className="mt-4 max-h-full w-full overflow-y-auto">
        {formAba === "Cadastro" && <FormCadastro credor={credor?.credor_crm} url={credor?.url_ws} />}
        {formAba === "Negociações" && <FormNeg />}
        {formAba === "Tabulações" && <Historico />}
        {!isConsulta && formAba === "Chamada" && <InfoChamada />}
        {formAba === "Propostas" && <FormPropostas />}
        {/* { />} */}
      </div>

      <ModalSucesso />
      <ModalErro />

      <GenericModal
        title={modalInfo.title}
        type={modalInfo.type}
        onClose={() => onClose()}
        show={modalInfo.isOpen && modalInfo.title === "Proximo Atendimento"}
        modalType="Proximo Atendimento"
      />

      {isMutation > 0 ? <div className=" flex justify-center items-center min-h-[80%] w-[52%] absolute m bg-white opacity-90  z-50 px-4 py-4">
        <Loader size={3.5} />
      </div> : <></>}
    </div>
  );
};
